import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

export const getImportAgentTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="import-agent-hero"]',
    popover: {
      title: t("bxAgentV2.tour.hero.title"),
      description: t("bxAgentV2.tour.hero.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="import-agent-tabs"]',
    popover: {
      title: t("bxAgentV2.tour.tabs.title"),
      description: t("bxAgentV2.tour.tabs.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="import-agent-new-import"]',
    popover: {
      title: t("bxAgentV2.tour.newImport.title"),
      description: t("bxAgentV2.tour.newImport.description"),
      side: "right",
      align: "start",
    },
  },
  {
    element: '[data-tour="import-agent-integrations"]',
    popover: {
      title: t("bxAgentV2.tour.integrations.title"),
      description: t("bxAgentV2.tour.integrations.description"),
      side: "top",
      align: "start",
    },
  },
  {
    element: '[data-tour="import-agent-recent-activity"]',
    popover: {
      title: t("bxAgentV2.tour.recentActivity.title"),
      description: t("bxAgentV2.tour.recentActivity.description"),
      side: "top",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const importAgentTourConfig = {
  id: "importAgent" as const,
  steps: getImportAgentTourSteps,
};
